import {
  Input,
  Output,
  Component,
  OnChanges,
  EventEmitter,
  SimpleChanges
} from '@angular/core';

import {
  ngHelper,
  IProductType,
  CustomNoteLabel,
  CUSTOM_NOTE_CONTEXT,
  IFormattedBakerySchedule,
  IFormattedDeviatingDeadline,
  PRODUCT_TYPE_STRUCTURE_TYPES
} from '@cakeiteasy/web-utils';
import { CUSTOM_NOTE_COLOR_MAP } from '@cakeiteasy/web-ui';

import {
  getCustomNoteLabel,
  getPickupAvailability,
  getDeliveryAvailability,
  getThirdPartyAvailability,
} from '../../../helpers';

@Component({
  standalone: false,
  selector: 'cake-info',
  templateUrl: './cake-info.component.html',
  styleUrls: ['./cake-info.component.scss']
})
export class CakeInfoComponent implements OnChanges {
  @Input() cake: IProductType;
  @Input() showBakeryInfo = true;
  @Input() orderDeadlines: IFormattedBakerySchedule[] | string;
  @Input() specialDeadlines: IFormattedDeviatingDeadline[];
  @Input() bakeryUrl: string;
  @Input() standAloneMode = false;
  @Input() disabledBackButton = false;
  @Input() isSinglePiecesCake = false;
  @Input() currency: string;
  @Input() showBakeryDeadline = true;
  @Input() showCustomNote = false;
  @Input() noteContext: CUSTOM_NOTE_CONTEXT = CUSTOM_NOTE_CONTEXT.WEBSHOP;
  @Input() isConcreteProductType: boolean;

  @Output() onBackButtonClicked = new EventEmitter<void>();
  @Output() onBakeryNameClicked = new EventEmitter<string>();
  @Output() onShowDelivery = new EventEmitter<void>();
  @Output() onShowPickup = new EventEmitter<void>();

  isPickUpAndDelivery: boolean;
  isPickUpOnly: boolean;
  isDeliveryOnly: boolean;
  isThirdPartyAvailable: boolean;

  minPrice: number;
  hasImage: boolean;
  isComplexWithOneSize: boolean;

  CUSTOM_NOTE_COLOR_MAP = CUSTOM_NOTE_COLOR_MAP;
  noteLabel: CustomNoteLabel;

  ngOnChanges(changes: SimpleChanges): void {
    ngHelper.ifChanged(changes, 'cake', () => this._init());
  }

  public showPickup() {
    this.onShowPickup.emit();
  }

  public showDelivery() {
    this.onShowDelivery.emit();
  }

  private _init() {
    this.hasImage = this.cake.images.length > 0;
    this.minPrice = Math.min(...this.cake.sizes.map(({ minPrice }) => minPrice));
    this.isComplexWithOneSize = this.cake.structureType === PRODUCT_TYPE_STRUCTURE_TYPES.COMPLEX
      && this.cake.sizes.length === 1;

    this.noteLabel = getCustomNoteLabel(this.cake, this.noteContext);

    this._initDeliveryParams();
  }

  private _initDeliveryParams() {
    const isPickupAvailable = getPickupAvailability(this.cake);
    this.isThirdPartyAvailable = getThirdPartyAvailability(this.cake);
    const canBeDeliveredToDoor = getDeliveryAvailability(this.cake) || this.isThirdPartyAvailable;

    this.isPickUpAndDelivery = isPickupAvailable && canBeDeliveredToDoor;
    this.isPickUpOnly = isPickupAvailable && !canBeDeliveredToDoor;
    this.isDeliveryOnly = !isPickupAvailable && canBeDeliveredToDoor;
  }
}
